module.exports = __webpack_public_path__ + "static/media/Gear.ac28fe28.svg";